import { getFunctions, httpsCallable } from "firebase/functions";

import {
  FunctionOptionsType,
  FunctionReturnType,
  FunctionsEnum,
} from "../domain/functions";

export const callFunction = <T extends FunctionsEnum>({
  func,
  opts,
}: {
  func: T;
  opts: FunctionOptionsType[T];
}) => {
  const functions = getFunctions();
  const callableFunction = httpsCallable(functions, func);

  return callableFunction(opts) as Promise<FunctionReturnType[T]>;
};
